import styled from 'styled-components'

const PayNav = styled.div`
  width: 1200px;
  margin: auto;
  margin-top: 19px;
  margin-bottom: 12px;

  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(233, 233, 233, 1);
  line-height: 30px;
`

export default {
  PayNav,
}
